import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageSelectorComponent } from '../components/language-selector/language-selector.component';

/**
 * SharedTranslationModule provides translation functionality
 * that can be imported by any component in the application
 */
@NgModule({
  declarations: [],
  imports: [CommonModule, TranslateModule.forChild(), LanguageSelectorComponent],
  exports: [TranslateModule, LanguageSelectorComponent]
})
export class SharedTranslationModule {}
